import computeClassName from '../../../../../../utils/computeClassName';

export default function CCIconMinus20x20({className}) {
  const computedClassName = computeClassName(className,'');
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={computedClassName}>
      <path d="M4.5 10.5H16.5" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round"/>
    </svg>
  );
}
